
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]"])
      });
    }
  